export const instructorCmsHelperText = 'Profiles for instructors to populate content in Workouts.';
